import React, { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { MapEstablishmentList } from './Widgets/MapEstablishmentList';
import Summary from './Widgets/Summary';

import OxygenSaturationSummary from './../../Establishment/Establishments/Summary/Widgets/OxygenSaturationSummary';
import DissolvedOxygenSummary from '../../Establishment/Establishments/Summary/Widgets/DissolvedOxygenSummary';
import TemperatureSummary from '../../Establishment/Establishments/Summary/Widgets/TemperatureSummary';
import SalinitySummary from '../../Establishment/Establishments/Summary/Widgets/SalinitySummary';
import ChlorophyllSummary from '../../Establishment/Establishments/Summary/Widgets/ChlorophyllSummary';
import TurbiditySummary from '../../Establishment/Establishments/Summary/Widgets/TurbiditySummary';
import { useSearchParams } from 'react-router-dom';

const DashboardVariable = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		document.title = 'SPED - Dashboard Variable';
	}, []);

	return (
		<React.Fragment>
			<div className='page-content'>
				<Container fluid>
					<Row>
						<Col xl={12}>
							<Summary code_siep={searchParams.get('code_siep')} />
						</Col>
						<Col xl={9}>
							<Row>
								<Col md={4}>
									<OxygenSaturationSummary
										title={'Saturación Oxígeno'}
										um={'%'}
										code_siep={searchParams.get('code_siep')}
										h100={false}
									/>
								</Col>
								<Col md={4}>
									<DissolvedOxygenSummary
										title={'Oxígeno Disuelto'}
										um={'mg/L'}
										code_siep={searchParams.get('code_siep')}
										h100={false}
									/>
								</Col>
								<Col md={4}>
									<TemperatureSummary
										title={'Temperatura'}
										um={'°C'}
										code_siep={searchParams.get('code_siep')}
										h100={false}
									/>
								</Col>
								<Col md={4}>
									<SalinitySummary
										title={'Salinidad'}
										um={'psu'}
										code_siep={searchParams.get('code_siep')}
										h100={false}
									/>
								</Col>
								<Col md={4}>
									<ChlorophyllSummary
										title={'Clorofila'}
										um={'µg/L'}
										code_siep={searchParams.get('code_siep')}
										h100={false}
									/>
								</Col>
								<Col md={4}>
									<TurbiditySummary
										title={'Turbidez'}
										um={'ntu'}
										code_siep={searchParams.get('code_siep')}
										h100={false}
									/>
								</Col>
							</Row>
						</Col>
						<Col xl={3}>
							<MapEstablishmentList
								title='Establecimientos'
								selectedEstablishmentSiep={searchParams.get(
									'code_siep'
								)}
								onSelectEstablishment={establishment => {
									setSearchParams({
										code_siep: String(establishment.code_siep),
									});
								}}
								zoom={8}
							/>
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default DashboardVariable;